import {UserProps} from "../../api/model/user";
import {UserState} from "../../redux/reducer/user";
import {CompanyProps} from "../../api/model/company";

/**
 * Retrieves a company based on the user's role and affiliation.
 *
 * @function getCompany
 * @param {boolean} isKlimaLinkAdmin - Indicates whether the user is an admin with KlimaLink access.
 * @param {number|string} usersCompanyId - The company ID associated with the user.
 * @param {Array<CompanyProps>} companies - List of companies available in the user's state.
 * @returns {CompanyProps} - The selected company object. Returns the company matching the user's ID if the user is an admin,
 * or the first company in the list. Returns an empty object if no companies are available.
 */
export const getCompany = (isKlimaLinkAdmin: UserProps["isKlimaLink"], usersCompanyId: UserProps["companyId"], companies: UserState['companies'],): CompanyProps => {
    if (companies) {
        if (isKlimaLinkAdmin) return companies.filter(company => company.id === usersCompanyId)[0]
        return companies[0]
    }
    return {} as CompanyProps
}

